import moment from "moment-timezone"

export default function useConvertDate() {
  const pcTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const currentTimeZone = localStorage.getItem("timeZone") || pcTimeZone
  const serverTimeZone = "ETC/Utc"

  const getCurrentTimeZone = () => {
    return currentTimeZone
  }

  const convertDate = (dt: string | Date) => {
    if (currentTimeZone === serverTimeZone) return new Date(dt)

    const mask = "YYYY-MM-DDTHH:mm:ss"
    const serverDate = moment.utc(dt, mask).tz(serverTimeZone)
    const convertedDate = serverDate.tz(currentTimeZone).format(mask)

    return new Date(convertedDate)
  }

  return { convertDate, pcTimeZone, currentTimeZone, getCurrentTimeZone }
}
